import { render, staticRenderFns } from "./fix.vue?vue&type=template&id=dd88e44e&scoped=true&"
import script from "./fix.vue?vue&type=script&lang=js&"
export * from "./fix.vue?vue&type=script&lang=js&"
import style0 from "./fix.vue?vue&type=style&index=0&id=dd88e44e&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd88e44e",
  null
  
)

export default component.exports